import React from 'react';
import cc from 'classcat';
import {
  type FieldError,
  type FieldValues,
  type Path,
  useController,
  useFormContext
} from 'react-hook-form';
import { Typography, TypographyVariant } from 'components/Typography';
import './fieldLabel.css';

interface Label<T extends FieldValues> {
  name: Path<T>;
  children: React.ReactNode | (({ error }: { error?: FieldError }) => React.ReactNode) | string;
}

const FieldLabel = <T extends FieldValues>({ children, name }: Label<T>) => {
  const { control } = useFormContext<T>();
  const {
    fieldState: { error }
  } = useController({ name, control });

  return (
    <Typography variant={TypographyVariant.BodyXs}>
      <label htmlFor={name} className={cc(['fieldLabel', { 'fieldLabel--error': error }])}>
        {typeof children === 'function' ? children({ error }) : children}
      </label>
    </Typography>
  );
};

export default FieldLabel;
